import terms from './terms-en';
import policy from './policy-en';

export default {
  emailAddress: 'Email',
  confimEmailAddress: 'Confirm Email Address',
  password: 'Password',
  confimPassword: 'Confirm Password',
  changePassword: 'Change Password',
  register: 'Register',
  accountExists: 'An account with this email id already exists',
  forgotPassword: 'Forgot password?',
  registedGoTologin: 'Already Registered? Login',
  successfulRegistration: 'Registration is Successful.',
  activationtEmailSent:
    'An email is sent to the registered email to activate account',
  continue: 'Continue',
  email: 'Email',
  login: 'Login',
  info:
    'The eVisa Burkina Faso is an electronic travel authorization issued by the government of Burkina Faso. eVisa is an entry requirement to travel to and within Burkina Faso. The Burkinabe eVisa is for touristic or family purpose. Visitors who enter Burkina Faso are required to present a valid eVisa at the port of entry.',
  application: 'Application',
  submitDocs: 'Submit Documents',
  privacyPayment: 'Privacy Payment',
  approval: 'Approval',
  termsAndConditions: 'Terms & Conditions',
  privacyPolicy: 'Privacy Policy',
  ministry: '© {{year}} eVisa-Ministry of Security',
  registerYet: "Didn't register yet?",
  alreadyRegistered: 'Already registered?',
  newApplication: 'New Application',
  myApplications: 'My Applications',
  applicationId: 'Application Id',
  applicationName: 'Applicant Full Name',
  status: 'Status',
  submissionDate: 'Submission Date',
  actions: 'Actions',
  view: 'View',
  resume: 'Resume',
  respondToVisaOfficer: 'Respond to Visa Officer',
  messageToApplicant: 'Message to Applicant',
  applicationForm: 'Application Form',
  back: 'Back',
  backTo: 'Back to Applications',
  saveAndContinue: 'Save & Continue',
  supportingDocs: 'Supporting Documents',
  docType: 'Document Type',
  filename: 'Filename',
  uploadMax: 'Upload',
  declarationAndPayment: 'Declaration',
  proceedTo: 'Proceed to Payments',
  declarationOfApplicant: 'Declaration of Applicant',
  checkBox1:
    'I declare the accuracy of the information provided on this request and I take responsibility for any entry errors.',
  checkBox2: 'I am informed that visa fees are not refundable in the event of refusal. See',
  checkBox2And: 'and',
  secureCardPayment: 'Select Payment Method',
  submitPayment: 'Proceed to Payment',
  summary: 'Summary:',
  firstName: 'First Name:',
  familyName: 'Family Name:',
  passportNumber: 'Passport Number:',
  paymentReceiptNumber: 'Payment Receipt Number',
  payment: 'Payment:',
  totalAmount: 'Total Amount:',
  paymentNotSuccessful: 'Payment is not Successful.',
  pleaseGoBack:
    'Please go back to the Payment options and choose another method',
  goToApplications: 'Go to applications',
  paymentSuccessful: 'Payment Successful.',
  applicationSuccessful: 'Application is Successful',
  applicationSubmitted:
    'Your visa application was successfully submitted to the Visa Officer for review and approval. You shall receive an email informing you about the outcome after the visa has been processed.',
  shortcode: 'Short Code:',
  print: 'Print',
  whatsNext: 'Whats Next?',
  applicationTracked:
    'Application status can be tracked by navigating to the applications list page',
  visaDetails: 'Visa Details',
  personalDetails: 'Personal Details',
  passportDetails: 'Passport Details',
  travelDetails: 'Travel Details',
  contactDetails: 'Contact Details',
  address: 'Address',
  homeAddress: 'Home address',
  emergencyContact: 'Emergency Contact',
  paymentSubtitle: 'Payment',
  visaFee: 'Visa Fee:',
  totalAmount2: 'Total Amount',
  send: 'Send',
  passwordSuccessfullyChanged: 'Your password has been successfully changed.',
  ok: 'Ok',
  emailResetPassword:
    'An email has been sent to you with instructions on how to reset your password.',
  visaType: 'Visa Type',
  visaPurpose: 'Visa Purpose',
  nationality: 'Nationality',
  surname: 'Surname',
  firstGivenNames: 'First/Given Names',
  dateBirth: 'Date of Birth',
  gender: 'Gender',
  countryBirth: 'Country of Birth',
  cityBirth: 'City of Birth',
  relantionship: 'Relantionship Status',
  occupation: 'Occupation',
  numberChildren: 'Number of Children',
  passportNumber2: 'Passport Number',
  placeIssue: 'Place of Issue',
  passportType: 'Passport Type',
  passportExpiry: 'Passport Expiry Date',
  passportIssue: 'Passport Issue Date',
  portEntry: 'Port of Entry',
  intendedDate:
    'Intended Date of Entry (give a range of 7 days before intended entry date)',
  maximumStay: 'Maximum length of stay (days)',
  destinationAddress: 'Address in',
  nameAndNumberIn:
    'Full Name and telephone number of the correspondent in',
  modesTransport: 'Modes of transportation',
  destinations: 'Destinations',
  mobileCellPhone: 'Mobile/Cell Phone',
  email2: 'Email Address',
  street: 'Street',
  city: 'City',
  state: 'State',
  postalCode: 'Postal code',
  countryResidence: 'Country of residence',
  fullName: 'Full Name',
  phoneNumber: 'Phone number',
  paymentMethod: 'Payment Methods',
  payment_method: 'Payment Method',
  paidAt: 'Payment Date',
  submitter: 'Submitter',
  cardName: 'Card Holder Name',
  cardNumber: 'Card Number',
  expirationDate: 'Expiration Date:',
  month: 'Month',
  year: 'Year',
  cvv: 'CVV',
  unspecified: 'Not Specified',
  supportingDocumentsCaption: "Documents marked with a '*' are required.",
  maxFileSizeSupporting:
    'Provide one of the following image file types: GPG, JPEG, PNG, TIFF, BMP, DOC, DOCX, PDF up to 1 MB',
  eitherOrDocSelectionPrompt: 'Select document type',
  cancel: 'Cancel',
  or: 'OR',
  close: 'Close',
  expiredSessionTitle: 'Session has expired',
  expiredSessionText: 'Your session has expired. Please login again',
  404: 'The page you are looking for was not found.',
  home: 'Home',
  onlineServices: 'Online Visa Service',
  eVisa: 'eVisa',
  enterEmailAddress: 'Enter email address',
  resetPassword: 'Reset Password',
  applicationID: 'Application ID:',
  shortCode: 'Application Short Code',
  uploadPaymentReceiptScan: 'Upload Payment Receipt Scan *',
  applicationDate: 'Application Date:',
  applicationNAME: 'Application Name:',
  visaP: 'Visa Purpose:',
  startWritingResponse: 'Start writing your response here',
  hotelOrContact: 'Hotel or Contact name',
  passwordResetConfirmation: 'Your password has been reset',
  resetPasswordNewPasswordTitle: 'Create New Password',
  requestResetPasswordTitle: 'Request Reset password',
  registrationTitle: 'Registration',
  awaitingFeedbackTitle: 'Send message',
  logInTitle: 'Log in',
  unableToLogin: 'Unable to login',
  applicationSummaryTitle: 'Application Summary',
  pageNotFound: 'Page Not Found',
  yourApplicationID: 'The Application ID:',
  emailSentTo: 'An Email was sent to ',
  withApplicationID: ' with the application id',
  unknownError: 'An unknown error occurred.',
  SERVER_ERROR: 'An unknown server error occured.',
  TIMEOUT_ERROR: 'Timed out while connecting to the server.',
  CONNECTION_ERROR: 'Unable to connect to the server.',
  NETWORK_ERROR: 'Unable to connect to the server due to a network error.',
  CANCEL_ERROR: 'Request cancelled.',
  supportingTypesCaption:
    'Only files with extensions (.doc/.pdf/.jpg) are accepted',
  mustBeAfterToday: 'Must be after today',
  mustBeOnOrAfterToday: 'Must be on or after today',
  mustBeOnOrBeforeToday: 'Must be on or before today',
  attachedFiles: 'Attached Files',
  chooseFile: 'Choose file',
  unsupportedDocType:
    'Unsupported file format. The following formats are supported: {{fileTypes}}',
  unsupportedImageFileType:
    'Unsupported file format. The following formats are supported: {{pictureFileTypes}}',
  imageFileTypeLabel:
    'Documents in the following formats can be uploaded: {{pictureFileTypes}}. Max file size is 1MB.',
  fileTypeLabel:
    'Documents in the following formats can be uploaded: {{fileTypes}}. Max file size is 1MB.',
  maxFileSizeExceeded:
    'Maximum file size exceeded. Please make sure the file is not larger than 1 MB.',
  mustBeBeforePassportExpireDate: 'Date must be before passport expire date',
  clear: 'Clear',
  apply: 'Apply',
  sendPaymentLink: 'Send Payment Link',
  paymentLinkSent: 'Payment link sent to applicant',
  pleaseWait: 'Please wait',
  serviceFee: 'Service Fees: {{amount}} {{currency}}',
  costOfVisa: 'Cost of Visa: {{amount}} {{currency}}',
  totalPaymentAmount: 'Total Payment Amount: {{amount}} {{currency}}',
  'Pay at Embassy': 'Pay at Embassy',
  rowsPerPage: 'Rows per page',
  finishPay: 'Apply payment',
  diplomaticMission: 'Diplomatic Organization',
  filter: {
    shortCode: 'Short code',
    lastName: 'Last name',
    status: 'Status',
    submitter: 'Submitter',
    visaForLocalPayment: 'Visa for local payment',
    submittedDateFrom: 'Submitted date from',
    submittedDateTo: 'Submitted date to',
  },
  paymentInfo: {
    header: 'Payment Pending',
    appId: 'Application Id: ',
    description:
      'After the payment of the visa fees, your application shall be processed. Please go to your closest embassy or diplomatic mission and pay for the application.',
    additional: 'You shall be required to present the information below:',
  },
  downloadPDF: 'Preview Application in PDF',
  confirmPDF:
    'I confirm that I have reviewed the PDF version of my application, especially the',
  biometricPhoto: 'quality of the biometric photo',
  submitted: 'submitted.',
  pleaseChooseFile: 'Please choose a file',
  noFileChosen: 'No file chosen',
  noUserForEmail: 'No user with this email address was found in the system',
  ...terms,
  ...policy,
};



// WEBPACK FOOTER //
// ./src/conf/translations/en.js